var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_24_1",
    "data-name": "Component 24 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_54",
    "data-name": "Ellipse 54",
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#7bb6c6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M487.9,593.616H467.891a2.5,2.5,0,0,0-2.5,2.5v17.749a2.5,2.5,0,0,0,2.5,2.5H487.9a2.5,2.5,0,0,0,2.5-2.5V596.113A2.5,2.5,0,0,0,487.9,593.616Zm-3.714,2.973a2.727,2.727,0,1,1-2.727,2.727A2.728,2.728,0,0,1,484.184,596.589Zm-17.012,15.935,6.475-12.731,5.519,9.808,3.653-5.4,5.661,8.326Z",
    transform: "translate(-456.894 -583.987)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImage);
export default __webpack_public_path__ + "static/media/icon-image.36108edc6a03798123b98c9792c2b03f.svg";
export { ForwardRef as ReactComponent };